import React from "react";
import {Column, Row, Spinner, Text} from "react-vcomponents";
import {Rect} from "../ThreeJS/VectorStructs.js";
import {BaseProps, BasicStyles} from "react-vextensions";
import {observer_mgl} from "mobx-graphlink";

export function RectFromPartialRect(partialRect: Partial<Rect>|n, yPlusMeansUp: boolean): Rect {
	return new Rect(partialRect?.x ?? 0, partialRect?.y ?? 0, partialRect?.width ?? 0, partialRect?.height ?? 0, yPlusMeansUp);
}
export const RectEditor = observer_mgl((props: {value: Rect, onChange?: (newRect: Rect)=>void} & BaseProps)=>{
	const {value: value_raw, onChange} = props;
	const value = RectFromPartialRect(value_raw, true);

	const ChangeRegion = (rectChanger: (rect: Rect)=>void)=>{
		const newRect = new Rect(value.x ?? 0, value.y ?? 0, value.width ?? 0, value.height ?? 0, true);
		rectChanger(newRect);
		onChange?.(newRect);
	};
	return (
		<Column style={BasicStyles(props)}>
			<Row mt={5}>
				<Text style={{minWidth: 53}}>Left:</Text>
				<Spinner ml={5} style={{width: 100}} min={-360} value={value.Left} onChange={val=>ChangeRegion(a=>a.Left = val)}/>
				<Text ml={5} style={{minWidth: 40}}>Right:</Text>
				<Spinner ml={5} style={{width: 100}} min={-360} value={value.Right} onChange={val=>ChangeRegion(a=>a.Right = val)}/>
			</Row>
			<Row mt={5}>
				<Text style={{minWidth: 53}}>Bottom:</Text>
				<Spinner ml={5} style={{width: 100}} min={-360} value={value.Bottom} onChange={val=>ChangeRegion(a=>a.Bottom = val)}/>
				<Text ml={5} style={{minWidth: 40}}>Top:</Text>
				<Spinner ml={5} style={{width: 100}} min={-360} value={value.Top} onChange={val=>ChangeRegion(a=>a.Top = val)}/>
			</Row>
		</Column>
	);
});